import { Badge } from '@/components/ui/badge'
import { statusLabel } from '@/domain/node'
import type { Status } from '@/domain/node'
import { cn } from '@/lib/utils'

// 상태 색은 셋뿐이다: 정상 · 경고 · 위험. 준비 중은 진행이지 상태가 아니라 색을 쓰지 않는다.
const TONE: Record<Status, string> = {
  ready: 'border-ok/35 bg-ok/10 text-ok-ink',
  paused: 'border-warn/50 bg-warn/15 text-warn-ink',
  failed: 'border-danger/35 bg-danger/10 text-danger-ink',
  preparing: 'border-border bg-transparent text-muted-foreground',
  offline: 'border-danger/35 bg-danger/10 text-danger-ink',
  awaiting: 'border-warn/50 bg-warn/15 text-warn-ink',
}

export function StatusBadge({
  status,
  className,
}: {
  status: Status
  className?: string | undefined
}) {
  return (
    <Badge variant="outline" className={cn('rounded-full font-normal', TONE[status], className)}>
      {statusLabel[status]}
    </Badge>
  )
}
